import './TabGroup.scss'

import { Location } from 'history'
import SvgLiveBadge from 'icons/LiveBadge'
import { buildQueryString, FILTER_QUERY_KEYS, PATHS } from 'lib/util/routing'
import ProductCategory from 'pages/Home/ProductCategory'
import Section from 'pages/Home/Section'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import Tab from './Tab'

export interface TabGroupProps extends RouteComponentProps {
  currentProductCategory: ProductCategory
  location: Location
  selectedSection: Section
}

export default withRouter(function TabGroup(props: TabGroupProps): JSX.Element {
  const { currentProductCategory, location, selectedSection } = props
  const [t] = useTranslation()

  const search = buildQueryString(location, FILTER_QUERY_KEYS)

  return (
    <div className="tab-group">
      <div className="tab-group__begin" />
      <div className="tab-group__tabs">
        {currentProductCategory !== ProductCategory.More && (
          <Link to={{ pathname: PATHS.videos, search }}>
            <Tab selected={selectedSection === Section.Videos}>{t('home.tabGroup.videos')}</Tab>
          </Link>
        )}
        <Link to={{ pathname: PATHS.webinars, search }}>
          <Tab selected={selectedSection === Section.RecordedWebinars}>{t('home.tabGroup.recordedWebinars')}</Tab>
        </Link>
        <Link to={{ pathname: PATHS.upcoming, search }}>
          <Tab className="upcoming--short" selected={selectedSection === Section.UpcomingWebinars}>
            {t('home.tabGroup.upcomingWebinarsShort')}
            <SvgLiveBadge className="tab-group__live" />
          </Tab>
          <Tab className="upcoming--long" selected={selectedSection === Section.UpcomingWebinars}>
            {t('home.tabGroup.upcomingWebinars')}
            <SvgLiveBadge className="tab-group__live" />
          </Tab>
        </Link>
        <div className="tab-group__fill" />
      </div>
      <div className="tab-group__begin" />
    </div>
  )
})
